import { useEffect, useState } from 'react';

export default function useRerender() {
  const [_, setFlag] = useState(false);

  useEffect(() => {
    setFlag(true);
  }, []);
}
